var _line, _line2, _line3, _line4, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTemplate3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 26,
    viewBox: "0 0 45 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 11,
    x2: 44,
    y2: 11,
    stroke: "#8F96A5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 15,
    x2: 44,
    y2: 15,
    stroke: "#8F96A5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 19,
    x2: 44,
    y2: 19,
    stroke: "#8F96A5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 23,
    x2: 44,
    y2: 23,
    stroke: "#8F96A5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 26,
    rx: 2,
    fill: "#8F96A5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 2,
    width: 19,
    height: 5,
    rx: 2.5,
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate3);
export default __webpack_public_path__ + "static/media/template-3.6f2be9d229c2830c6f0aaa79df812684.svg";
export { ForwardRef as ReactComponent };